import { Stack } from "@mui/material";
import { FC } from "react";

import { Section1 } from "page-sections/home-page/Section-1";
import { Section2 } from "page-sections/home-page/Section-2";
import { Section3 } from "page-sections/home-page/Section-3";
import { Section4 } from "page-sections/home-page/Section-4";
import { Section6 } from "page-sections/home-page/Section-6";
import { Section7 } from "page-sections/home-page/Section-7";
import { Section8 } from "page-sections/home-page/Section-8";
import { AirdropSection } from "page-sections/home-page/AirdropSection";

const HomePage: FC = () => {
  return (
    <Stack
      sx={{
        "& section": {
          height: "100vh",
          overflowX: "hidden",
          position: "relative",
          scrollSnapAlign: "center",
        },
      }}
    >
      <Section1 />
      <AirdropSection />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section6 />
      <Section7 />
      <Section8 />
    </Stack>
  );
};

export default HomePage;
